<div class="ml-2 mr-2 mb-5" style="width: 100%;">
    <div class="flex justify-content-start">
        <img src="assets/img/logo_CORTEVA_footer1.png" />
    </div>
</div>